import { useState, useEffect, useContext } from "react";
import { AuthContext } from "../../context/AuthProvider";
import { authService } from "../../services";
import { useNavigate, Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUser } from "@fortawesome/free-solid-svg-icons";

const Login = () => {
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState(false);
  const { login, user, loading } = useContext(AuthContext);
  const [loadingStatus, setLoadingStatus]=useState(false)
  const navigate = useNavigate();
useEffect(()=>{
if(user && !loading){
  navigate("/admin"); 
}
}, [loading])

  const handleChange = (e) =>
    setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setLoadingStatus(true)
      const userData = await authService.login(form);
      login(userData.token);//set userdata to contex
      const redirectPath=sessionStorage.getItem("redirectPath")
      if(redirectPath){
        navigate(redirectPath)
        sessionStorage.removeItem("redirectPath")
      }else{
        navigate("/admin"); 
      }
      setLoadingStatus(false)
    } catch (error) {
      setLoadingStatus(false)
    setError({message:error.message})
    }
  };
if(loading){
  return <h1>Loadding...</h1>
}
  return (
    <div className="w-100 pt-3 min-h-[70vh] mb-6">
   <form
        onSubmit={handleSubmit}
        className=""
        >
        <h2 className="mb-8 text-gray-800 text-4xl">Login</h2>
        <FontAwesomeIcon
          icon={faUser}
          size="5x"
          className="text-gray-700 block mx-auto"
        />
        <h5>Welcome back. Login to see your music streams</h5>
        {error ? (
          <h6 className="Login-error text-red-900 block">{error?.message }</h6>
        ) : null}
        <input 
          type="email"
          name="email"
          placeholder="Email"
          onChange={handleChange}
          required
        />
        <input
          type="password"
          name="password"
          placeholder="Password"
          onChange={handleChange}
          required
        />
        <div className="text-left -mb-2">
          Don't have an account? <Link className="udderline text-blue-500" to="/sign-up">Sign Up</Link>
        </div>
        <button
          className="formSubmitBtn"
          type="submit"
          disabled={loadingStatus}
        >
         {loadingStatus? "Signing in..." : "Login" }
        </button>
        <div className="flex justify-between mt-1">
          <div className="flex justify-left w-1/2 gap-1">
            <div>
              <input type="checkbox" className="accent-gray-900 mt-1 cursor-pointer"></input> 
              </div>
            <div>Remember
            Me</div>
          </div>
          <div className="underline text-blue-500">
            <Link to="/forget-password">Forget Password</Link>
          </div>
        </div>
      </form>
    </div>
  );
};

export default Login;
